export default __webpack_public_path__ + "static/media/frame_corner_top_left_gray.d72a239b.png";